module.exports = __webpack_public_path__ + "img/image (7).2083b33f.webp";